export const exampleJobTitlesBySubFamilyCode: Record<string, string[]> = {
  "AA.A": ["Administrative Assistant", "Department Coordinator", "Executive Assistant"],
  "AA.G": ["Office Clerk", "Office Manager", "Administrative Coordinator"],
  "AA.L": ["Translator", "Linguistics Specialist", "Language Services Coordinator"],
  "AA.M": ["Mailroom Clerk", "Mailroom Supervisor", "Package Distribution Coordinator"],
  "AA.R": ["Receptionist", "Front Desk Coordinator", "Switchboard Operator"],
  "AA.T": ["Travel Coordinator", "Travel Consultant", "Corporate Travel Specialist"],
  "AA.X": ["Administrative Specialist", "Office Support Coordinator", "Admin Services Assistant"],
  "AC.A": [
    "Business Process Analyst",
    "Process Improvement Specialist",
    "Operational Excellence Consultant",
  ],
  "AC.B": ["Strategy Analyst", "Business Strategy Consultant", "Corporate Strategy Advisor"],
  "AC.C": [
    "Communications Manager",
    "Corporate Communications Specialist",
    "Public Relations Coordinator",
  ],
  "AC.D": [
    "Corporate Development Analyst",
    "Mergers and Acquisitions Consultant",
    "Strategic Partnership Manager",
  ],
  "AC.E": [
    "Community Affairs Manager",
    "Corporate Social Responsibility Coordinator",
    "Public Affairs Specialist",
  ],
  "AC.I": [
    "Investor Relations Specialist",
    "Shareholder Communications Manager",
    "Financial Communications Coordinator",
  ],
  "AC.O": ["Business Analyst", "Data Analyst", "Business Metrics Specialist"],
  "AC.P": ["Project Manager", "Internal Project Lead", "Program Management Specialist"],
  "AC.Q": ["Quality Assurance Specialist", "Corporate Quality Auditor", "Compliance Coordinator"],
  "AC.R": ["Real Estate Manager", "Property Portfolio Specialist", "Corporate Real Estate Analyst"],
  "AC.S": [
    "Sustainability Coordinator",
    "Environmental Strategy Analyst",
    "Corporate Sustainability Manager",
  ],
  "AC.T": [
    "Change Management Specialist",
    "Organizational Development Consultant",
    "Integration Project Manager",
  ],
  "AC.U": ["Purchasing Agent", "Procurement Specialist", "Inventory Control Analyst"],
  "AC.X": [
    "Corporate Support Specialist",
    "Business Operations Coordinator",
    "Support Services Manager",
  ],
  "AD.A": ["Data Analyst", "Statistical Analyst", "Data Visualization Specialist"],
  "AD.B": ["Data Scientist", "Machine Learning Engineer", "Big Data Analyst"],
  "AD.C": [
    "Customer Insights Analyst",
    "E-commerce Data Analyst",
    "Marketing Analytics Specialist",
  ],
  "AD.M": ["Data Management Specialist", "Master Data Analyst", "Data Governance Coordinator"],
  "AD.R": ["Reporting Analyst", "Data Reporting Specialist", "Database Reporting Consultant"],
  "AD.X": ["Data Services Specialist", "Information Analyst", "Data Operations Coordinator"],
  "AF.A": ["Accountant", "Financial Reporting Analyst", "General Ledger Specialist"],
  "AF.B": ["Revenue Accountant", "Sales Accounting Analyst", "Revenue Recognition Specialist"],
  "AF.C": ["Corporate Controller", "Division Controller", "Financial Reporting Manager"],
  "AF.D": ["Credit Analyst", "Collections Specialist", "Accounts Receivable Coordinator"],
  "AF.F": ["Fraud Analyst", "Risk Mitigation Specialist", "Fraud Prevention Consultant"],
  "AF.G": ["Finance Generalist", "Financial Analyst", "Financial Operations Manager"],
  "AF.H": ["Payroll Specialist", "Payroll Administrator", "Compensation Analyst"],
  "AF.I": [
    "IT Auditor",
    "Information Systems Audit Specialist",
    "Cybersecurity Compliance Auditor",
  ],
  "AF.K": ["Risk Manager", "Corporate Risk Analyst", "Enterprise Risk Consultant"],
  "AF.L": ["Cost Accountant", "Cost Analysis Specialist", "Pricing Analyst"],
  "AF.M": ["Asset Manager", "Asset Strategy Analyst", "Investment Portfolio Manager"],
  "AF.O": [
    "Stock Plan Administrator",
    "Equity Compensation Specialist",
    "Employee Stock Plan Manager",
  ],
  "AF.P": ["Financial Planning Analyst", "FP&A Specialist", "Budget Analyst"],
  "AF.R": [
    "Government Accounting Specialist",
    "Federal Contracts Accountant",
    "Regulatory Compliance Accountant",
  ],
  "AF.S": [
    "Financial Systems Analyst",
    "Finance Systems Implementation Specialist",
    "ERP Systems Manager",
  ],
  "AF.T": ["Tax Analyst", "Corporate Tax Specialist", "Tax Compliance Officer"],
  "AF.U": ["Audit Specialist", "Compliance Analyst", "Internal Controls Coordinator"],
  "AF.V": ["Accounts Receivable Specialist", "Accounts Payable Coordinator", "Billing Analyst"],
};
